import React from 'react'
import { useCountAiUserThreads } from '../../../../api/denaliAssistant'
import FadeIn from '../../../../components/molecules/Transitions/FadeIn'

function UserThreadCount () {
  const { data, isLoading } = useCountAiUserThreads()

  if (isLoading) return null
  if (!data) return null

  return (
    <FadeIn className='font-size-xs'>{data} Threads</FadeIn>
  )
}

export default UserThreadCount
